export default {
  number: '21403734',
  display: '21 40 37 34',
  currency: 'NOK',
  tracking: {},
};
